import {
  external_push_repository,
} from '@/repositories';

const actions = {
  async pushContactToCrm(_, { organization_id, input }) {
    const result = await external_push_repository.pushContactToCrm(organization_id, input);

    return result;
  },
  async getFormProviderSettings(_, { organization_id }) {
    const result = await external_push_repository.getFormProviderSettings(organization_id);

    return result;
  },
};

export default {
  actions,
  namespaced: true,
};
